// extracted by mini-css-extract-plugin
export default {"container":"markupLayout_container__uMp7J"};